import {
  InputField,
  UploadImageField,
  LoaderButton
} from 'components/molecules'
import { WEB_URL_CONSTANTS } from 'constants/web-url-constants'
import MerchantSelectSearchField from 'domains/merchant/molecules/select-search-field'
import CmsBlogPostSelectSearchField from 'domains/cms-blog-post/molecules/select-search-field'
import { Form, Formik } from 'formik'
import PropTypes from 'prop-types'
import React from 'react'
import { Col, Row } from 'reactstrap'

const propTypes = {
  cms_merchant: PropTypes.shape({
    merchant: PropTypes.shape({
      id       : PropTypes.number,
      name     : PropTypes.string,
      username : PropTypes.string,
      url_key  : PropTypes.string
    }),
    merchant_id    : PropTypes.number,
    bio            : PropTypes.string,
    hero_image_url : PropTypes.string,
    hero_video_url : PropTypes.string,
    blog_post_id   : PropTypes.number
  }),
  buttonText       : PropTypes.string,
  heroImage        : PropTypes.object,
  sliderImage      : PropTypes.object,
  url              : PropTypes.string,
  isEditAction     : PropTypes.bool,
  setHeroImage     : PropTypes.func,
  setSliderImage   : PropTypes.func,
  validationSchema : PropTypes.object,
  handleSubmitForm : PropTypes.func.isRequired
}

const defaultProps = {
  cms_merchant: {
    merchant: {
      id       : 0,
      name     : '',
      username : '',
      url_key  : ''
    },
    merchant_id    : '',
    bio            : '',
    hero_image_url : '',
    hero_video_url : '',
    blog_post_id   : 0
  },
  buttonText       : '',
  heroImage        : new Blob(),
  sliderImage      : new Blob(),
  url              : '',
  isEditAction     : false,
  setHeroImage     : () => {},
  setSliderImage   : () => {},
  validationSchema : {},
  handleSubmitForm : () => {}
}

/**
 * Form to create and edit CMS Merchant
 */

const CmsMerchantForm = ({
  cms_merchant,
  isEditAction,
  buttonText,
  heroImage,
  sliderImage,
  setHeroImage,
  setSliderImage,
  validationSchema,
  handleSubmitForm
}) =>  (
  <Formik
    enableReinitialize={ true }
    initialValues={ cms_merchant }
    validationSchema={ validationSchema }
    onSubmit={ handleSubmitForm }
  >
    {
      (formikBag) => (
        <>
          {
            formikBag.values.merchant.url_key?
              <h3>
                { 'Go to Merchant page ' }
                <a
                  className='text-primary'
                  href={ `${WEB_URL_CONSTANTS.HOMEPAGE}/merchants/${formikBag.values.merchant.url_key}` }
                  target='_blank' rel='noopener noreferrer'
                >
                  { 'here' }
                </a>
              </h3>
              :
              null
          }

          <Form>
            <MerchantSelectSearchField
              name={ isEditAction ? 'merchant.id' : 'merchant_id' }
              label='Merchant'
              disabled={ isEditAction }
              required={ true }
              valueType={ 'number' }
            />

            <InputField
              type='textarea'
              rows='5'
              name='bio'
              label='Bio'
              placeholder=''
              required={ true }
            />
            <InputField
              type='text'
              name='hero_video_url'
              label='Hero Video Url'
              placeholder='https://www.youtube.com/embed/oT1ruIpX4nE'
              required={ false }
            />

            <CmsBlogPostSelectSearchField
              name='blog_post_id'
              label='Blog Post'
              required={ true }
            />

            <UploadImageField
              id='output-hero-image'
              label='Cover Image'
              image={ heroImage }
              required={ true }
              initialImageSrc={ formikBag.values.hero_image_url }
              setValue={ (input) => {
                setHeroImage(input)
              } }
            />
            <UploadImageField
              id='output-slider-image'
              label='Thumbnail/ Slider Image'
              image={ sliderImage }
              required={ true }
              initialImageSrc={ formikBag.values.slider_image_url }
              setValue={ (input) => {
                setSliderImage(input)
              } }
            />

            <Row >
              <Col>
                <LoaderButton
                  className='float-right'
                  color='success'
                  isLoading={ formikBag.isSubmitting }
                  onClick={ formikBag.submitForm }
                  text={ buttonText }
                />
              </Col>
            </Row>

          </Form>
        </>
      )
    }
  </Formik>
)

CmsMerchantForm.propTypes    = propTypes
CmsMerchantForm.defaultProps = defaultProps

export default CmsMerchantForm
